import { FilterConfig, FilterQuery } from '@monolog/shared/types';

// Create new enums for filter routes here
export enum FilterType {
  storeCredit = 'STORE_CREDIT',
  claim = 'CLAIM',
  order = 'ORDER',
  payout = 'PAYOUT',
}

export type FilterOptions = {
  startTitle?: string;
  hideAddButton?: boolean;
  hideClearButton?: boolean;
  hideDeleteButton?: boolean; // we can add string[] for filter fields for granular control
  hideOperator?: boolean; // we can add string[] for filter fields for granular control
  addFilterFn?: (availableFilters: FilterConfig[], appliedFilters: FilterQuery[]) => FilterQuery[];
};
